<div class="donations-container">
  <div class="donations-content">
    <div class="donations-header">
      <h1>Ruku na Srce Donacije</h1>
      <p class="subtitle">Vaša donacija može zaista promijeniti živote ljudi.</p>
    </div>

    <div class="donation-form-container">
      <form [formGroup]="donationForm" (ngSubmit)="onSubmit()" class="donation-form">
        <div class="form-group">
          <label for="name">Vaše ime</label>
          <input 
            type="text" 
            id="name" 
            formControlName="name" 
            placeholder="Enter your name"
            class="form-control"
          >
          <div class="error-message" *ngIf="donationForm.get('name')?.invalid && donationForm.get('name')?.touched">
            Molimo unesite vase ime
          </div>
        </div>

        <div class="form-group">
          <label for="amount">Visina donacije (BAM)</label>
          <input 
            type="number" 
            id="amount" 
            formControlName="amount" 
            placeholder="Enter amount"
            class="form-control"
            min="1"
          >
          <div class="error-message" *ngIf="donationForm.get('amount')?.invalid && donationForm.get('amount')?.touched">
            Molimo unesite validnu visinu donacije
          </div>
        </div>

        <button 
          type="submit" 
          class="submit-button"
          [disabled]="donationForm.invalid"
        >
          Continue to Payment
        </button>
      </form>

      <div id="paypal-button-container" *ngIf="showPaypalButton"></div>
    </div>

    <div class="donation-info">
      <div class="info-card">
        <h3>Zasto Donirati?</h3>
        <p>Zašto donirati? Vaš doprinos nam pomaže da nastavimo našu misiju podrške onima kojima je pomoć potrebna. Svaka donacija, bez obzira na veličinu, ima značajan utjecaj..</p>
      </div>
      <div class="info-card">
        <h3>Kako vaša donacija pomaže</h3>
        <ul>
          <li>Omogućuje osnovne resurse porodicama</li>
          <li>Podržava programe zajednice</li>
          <li>Omogućava hitnu pomoć</li>
          <li>Finansira obrazovne inicijative</li>
        </ul>
      </div>
    </div>
  </div>
</div>
